import { render, staticRenderFns } from "./CertificateEditor.vue?vue&type=template&id=aeee8fb6&scoped=true&"
import script from "./CertificateEditor.vue?vue&type=script&lang=js&"
export * from "./CertificateEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeee8fb6",
  null
  
)

export default component.exports